export default { sysList: [{ label: '91通讯录', value: '91通讯录' }] };
